import $ from "jquery";

$(".tabs-head-1").on("click", function() {
  $(".tabs").removeClass("show-2");
  $(".tabs").addClass("show-1");
});

$(".tabs-head-2").on("click", function() {
  $(".tabs").removeClass("show-1");
  $(".tabs").addClass("show-2");
});
